import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ChevronDown = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19.0117 9.20054L12.0117 15.8005L5.01172 9.20054",
            stroke: "currentColor",
            strokeWidth: 2 * (24 / size),
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
